import React from 'react'
import { Grid, Card, CardContent, Typography, Box } from '@mui/material'
import { isInteractiveClick } from '../../../util/clickGuards'

export default class BlockCardPerson extends React.Component {
    constructor(props) {
        super(props)
    }

    handleContent(event, dossier) {
        if (isInteractiveClick(event)) return

        window.location.replace(`/contentdossier/${dossier.id}`)
    }

    getImageContent(imageField, dossierData) {
        if (!dossierData) {
            return ''
        }

        let baseUrl = this.props.kedo.api().getBaseUrl()
        let singleDossierData = false
        singleDossierData = dossierData.find(
            (data) => data.content.id === imageField.id
        )
        if (singleDossierData && singleDossierData.content) {
            singleDossierData = singleDossierData.content.content
        }

        if (!singleDossierData || singleDossierData.length <= 0) {
            return ''
        }

        return (
            <img
                alt=""
                src={`${baseUrl}/file/${singleDossierData[0].id}/download`}
            />
        )
    }

    renderContentCard(dossierData, dossier, listItems) {
        const col = this.props.block.col

        if (
            !this.props.block ||
            !this.props.block.settings ||
            !this.props.block.settings.templateOptions
        ) {
            return null
        }

        let pictureId = this.props.block.settings.templateOptions.picture
        let pictureField = listItems.find(
            (listItem) => listItem.id === pictureId
        )

        let titleId = this.props.block.settings.templateOptions.title
        let titleField = listItems.find((listItem) => listItem.id === titleId)

        let descId = this.props.block.settings.templateOptions.description
        let descField = listItems.find((listItem) => listItem.id === descId)

        const mdCol = col && col >= 6 && col <= 12 ? col : 12
        const lgCol = col && col > 0 && col <= 12 ? col : 12

        return (
            <Grid size={{ xs: 12, md: mdCol, lg: lgCol }} key={dossier.id}>
                <Card
                    sx={{ mt: 3, cursor: 'pointer' }}
                    onClick={(event) =>
                        this.props.handleContent(event, dossier)
                    }
                >
                    {pictureField ? (
                        <Box sx={{ overflow: 'hidden', maxHeight: 200 }}>
                            {this.getImageContent(pictureField, dossierData)}
                        </Box>
                    ) : null}
                    <CardContent>
                        <Typography variant="h6" component="h2">
                            <a
                                href={`/contentdossier/${dossier.id}`}
                                style={{
                                    textDecoration: 'none',
                                    color: 'inherit',
                                }}
                            >
                                {titleField
                                    ? this.props.getValue(
                                          titleField,
                                          dossierData,
                                          dossier
                                      )
                                    : dossier.summary}
                            </a>
                        </Typography>
                        {descField ? (
                            <Typography variant="body2" color="text.secondary">
                                {this.props.getValue(
                                    descField,
                                    dossierData,
                                    dossier
                                )}
                            </Typography>
                        ) : null}
                    </CardContent>
                </Card>
            </Grid>
        )
    }

    render() {
        if (
            !this.props.block ||
            !this.props.block.settings ||
            !this.props.block.settings.templateOptions
        ) {
            return null
        }

        return (
            <Grid container spacing={2}>
                {this.props.data.dossiers.map((dossier) => {
                    const dossierData = this.props.data.contents.filter(
                        (dataItem) => dataItem.id === dossier.id
                    )
                    return this.renderContentCard(
                        dossierData,
                        dossier,
                        this.props.listItems
                    )
                })}
            </Grid>
        )
    }
}
